import { useApiHook } from './api';

export const LOCATION_ENTITY = {
  appLogic: useApiHook,
};
